import { usePermissions } from '@nucleus-commerce/admin-kit/permissions';

import { useNotificationTemplates } from '@/features/notifications';

/** The store's recovery email switch; null when the member cannot read notification settings. */
export function useRecoveryTemplateEnabled(storeId: string): boolean | null {
  const { can } = usePermissions();
  const templates = useNotificationTemplates(storeId, can('settings.read'));
  return (
    templates.data?.find((template) => template.event === 'checkout.abandoned')?.isEnabled ?? null
  );
}
